import { Button, ButtonOwnProps } from "@mui/material";
import React, { CSSProperties, Fragment, useState } from "react";
import { AskCertificate, AskMDLToken, FetchCertificationResult } from "../Data/User/PhoneCertification";
import LoadingCircle from "./LoadingCircleAnimated";

const PhoneCertButton = ({disabled, onSuccess, onFail, style, className, ...otherOption}: ButtonOwnProps & {
    disabled: boolean,
    onSuccess: (response: {name: string, birthday: string, phoneNumber: string}) => void, 
    onFail: (error?: any) => void,
    style?: CSSProperties,
    className?: string
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    return <Fragment>
        <Button
            disableElevation variant="contained" className={`DialogCTA ${className}`}
            {...otherOption}
            disabled={disabled || isLoading || isAuthenticated}
            style={style}
            onClick={()=>{
                
                (async()=>{
                    try {
                        
                        setIsLoading(true);

                        let mdl_tkn = await AskMDLToken();
                    
                        try{
                            await AskCertificate(mdl_tkn);
                        }catch(e){
                            // eslint-disable-next-line no-throw-literal
                            throw({name: 'failOnAskCertificate', result: e, message: '팝업 차단을 해제해 주세요.'} as Error);
                        }
                
                        const result = await FetchCertificationResult(mdl_tkn);
                        
                        if (result && result.code === 200){
                            setIsAuthenticated(true);
                            
                            onSuccess({
                                name: result.user.RSLT_NAME,
                                birthday: result.user.RSLT_BIRTHDAY,
                                phoneNumber: result.user.TEL_NO
                            });

                        } else {
                            // eslint-disable-next-line no-throw-literal
                            throw({name: 'failOnFetchCertificationResult', result, message: '인증이 중단되었어요.'} as Error);
                        }
                    } catch (e) {
                        setIsLoading(false);
                        
                        onFail(e);

                    }
                    
                    setIsLoading(false);
                })();
            }
        }>
            {"본인 인증하기"}
        </Button>
        <LoadingCircle show={isLoading}/>
    </Fragment>
}

export default PhoneCertButton;